import {AfterViewInit, Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators
} from "@angular/forms";
import {CoreService} from "../../../../../services/core/core.service";
import {first, pairwise, startWith} from "rxjs/operators";
import {SharedService} from "../../../../shared/shared.service";
import {BidService} from "../../bid.service";
import {ScopeDataService} from "../../../../setting/scope/scope.data.service";
import {BackendApiService} from "../../../../../services/backend-api.service";
import {Subscription} from "rxjs";
import { ToasterService } from '../../../../../services/core/toaster.service';
import { SubofficeService } from 'src/app/modules/setting/company-settings/suboffice/suboffice.service';

@Component({
    selector: 'app-scope-stage-form',
    templateUrl: './scope-stage-form.component.html',
    styleUrls: ['./scope-stage-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ScopeStageFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ScopeStageFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ScopeStageFormComponent implements OnInit, AfterViewInit {

  @Input() isEdit: boolean = false;
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);

  public sources: any[] = [];
  public scopes: any[] = [];
  public stages: any[] = [];
  public bidTypes: any[] = [];
  //@ts-ignore
  public scopeStageFormSubscription: Subscription;
  public tenantIdSubscription: Subscription = new Subscription();
  public isFormTouched = false;


  public scopeStageForm: UntypedFormGroup = new UntypedFormGroup({
    source_id: new UntypedFormControl(null, []),
    scopes: new UntypedFormControl(null, [Validators.required]),
    bid_types: new UntypedFormControl(null,[]),
    probability: new UntypedFormControl(null),
    stage_id: new UntypedFormControl(null,[Validators.required]),
    description: new UntypedFormControl(null),
    // is_prevailing_wage: new UntypedFormControl(null),
    // is_union: new UntypedFormControl(null),
    // is_open_shop: new UntypedFormControl(null),
  });

  constructor(
    public scopeDataService: ScopeDataService,
    public sharedService: SharedService,
    public coreService: CoreService,
    public bidService: BidService,
    public backendApiService: BackendApiService,
    public toasterService: ToasterService,
    public subofficeService: SubofficeService
  ) { }


  ngOnInit(): void {
    this.initSubscriptions();
    // this.getSources();
    // this.getScopes();
    this.getStages();
    // this.getBidTypes();

    this.tenantIdSubscription = this.subofficeService.tenantId$.subscribe((tenantId) => {

      if(typeof tenantId == 'number') {
        this.getSources({ tenant_id: tenantId });
        this.getScopes({ tenant_id: tenantId });
        this.getBidTypes({ tenant_id: tenantId });
      }

    });
  }

  ngAfterViewInit(): void {
    this.setDataOnEdit();
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === ' ') {
      event.preventDefault(); // Prevent default behavior (opening dropdown)
      event.stopPropagation(); // Stop event propagation to prevent other actions
    }
  }

  setDataOnEdit = () => {
    if(this.isEdit) {
      this.scopeStageForm?.setValue({
        source_id: this.model?.source ? this.model?.source  : null,
        scopes: this.model?.scopes,
        bid_types: this.model?.bid_types,
        probability: this.model?.probability,
        stage_id: this.model?.status,
        description: this.model?.description,
        // is_prevailing_wage: this.model?.is_prevailing_wage,
        // is_union: this.model?.is_union,
        // is_open_shop: this.model?.is_open_shop,
      });
      /*this.scopeStageForm?.get('source_id')?.setValue(this.model?.source);
      this.scopeStageForm?.get('scopes')?.setValue(this.model?.scopes);
      this.scopeStageForm?.get('bid_types')?.setValue(this.model?.bid_types);
      this.scopeStageForm?.get('probability')?.setValue(this.model?.probability);
      this.scopeStageForm?.get('stage_id')?.setValue(this.model?.stage);
      this.scopeStageForm?.get('description')?.setValue(this.model?.description);*/
    }
  }

  onRemove(event: any) {
    if(this.isEdit){
      if('proposal_scope_id' in event.value && event.value['proposal_scope_id']){
        const scopeVals = this.scopeStageForm.get('scopes')?.value;
        scopeVals.push(event.value);
        this.scopeStageForm.get('scopes')?.setValue([...scopeVals]);
        this.toasterService.showError('Not allowed to remove scopes that are used in any bid proposal' );
      }
    }
  }

  getSources = (queryParam: any) => {
    this.sharedService.getSources(queryParam)
      .pipe(first())
      .subscribe(
        (data:any) => {
          this.sources = data.data.map((source:any)=>{
            return {id: source.id, name: source.name};
          });
        });
  }

  getScopes = (queryParam: any) => {
      this.scopeDataService.userSelectedScopesList(queryParam)
        .subscribe((response: any) => {
          this.scopes = response.data;
          if(this.isEdit){
            // Create a map for quick lookup of new objects by id
            const newArrayMap = new Map(this.model?.scopes.map((item: any) => [item.id, item]));
            // Replace objects in originalArray with objects from newArray based on id
            const updatedArray = this.scopes.map(item => {
                return newArrayMap.has(item.id) ? newArrayMap.get(item.id) : item;
            });
            this.scopes = updatedArray;
          }
        });
  }

  getStages = () => {
    // this.sharedService.getStages()
    //   .pipe(first())
    //   .subscribe(
    //     (data:any) => {
    //       this.stages = data.data.map((stage:any)=>{
    //         return {id: stage.id, name: stage.name};
    //       });
    //     });
    this.backendApiService.getApi('statuses/bid')
      .subscribe((response: any)=>{
        this.stages = response.data;
        if (!this.scopeStageForm.get('stage_id')?.value){
          const defaultStage = this.stages.find((x : any) => x.default_status == 1);
          this.scopeStageForm.get('stage_id')?.setValue(defaultStage);
        }
      })
  }

  getBidTypes = (queryParam: any) => {
    // this.sharedService.getBidTypes()
    //   .pipe(first())
    //   .subscribe(
    //     (data:any) => {
    //       this.bidTypes = data.data.map((getBidType:any)=>{
    //         return {id: getBidType.id, name: getBidType.name};
    //       });
    //     });

    this.backendApiService.postApi('bid-types', queryParam)
      .subscribe((response: any)=>{
        this.bidTypes = response.data;
      })
  }

  onChangeUnionOptions(e: any){

  }

  public onTouched: () => void = () => {};

  writeValue(val: any): void {
    val && this.scopeStageForm.setValue(val, { emitEvent: false });
  }

  registerOnChange(fn: any): void {
    this.scopeStageForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.scopeStageForm.disable() : this.scopeStageForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null{
    return this.scopeStageForm.valid ? null : { invalidForm: {valid: false, message: "Assignment Detail Form are invalid"}};
  }

  initSubscriptions(){
    if (this.form){
      this.scopeStageFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched && !this.isFormTouched){
            this.isFormTouched = true;
            this.touchFormControls();
          }
        });
    }

  }
  touchFormControls(){
    Object.keys(this.scopeStageForm.controls).forEach(key => {
      this.scopeStageForm.get(key)?.markAsTouched();
    });
  }
  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.scopeStageFormSubscription?.unsubscribe();
    this.tenantIdSubscription?.unsubscribe();
  }



}
